import get from 'lodash/get';
import toArray from 'lodash/toArray';
import merge from 'lodash/merge';
import validateCaseLogicDescription from './validateCaseLogicDescription';

function validateEffectChains(caseConf, effectChains) {
  const errors = [];
  const warnings = [];

  let nodeIdMap = {};
  if (effectChains.length) {
    const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));
    const ecNodes = nodes.filter(node => node.name === 'EffectChain');
    for (const ecNode of ecNodes) {
      const id = get(ecNode, 'data.effectChain.id');
      nodeIdMap[id] = ecNode.id;
    }
  }

  // Search for medication checks, and verify that medications used
  // within those checks are enabled in case
  effectChains.forEach(ec => {
    const parentNodeId = nodeIdMap[ec.id];
    const medication = ec.medication;
    if (ec.error) {
      // Failed to fetch
      errors.push({
        message: 'Missing Effect chain',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: parentNodeId,
          metadata: {
            scope: 'control',
          },
      })
      return;
    }

    // Validate the EC in the scope of the caseConf
    const {warnings: ecWarnings, errors: ecErrors} = validateCaseLogicDescription({
      ...caseConf,
      caseLogicDescription: ec,
    }, {
      isEffectChain: true,
      isMedicationEffectChain: !!medication,
    });
    const scopeErrorToEcNodeOrMedication = (warningOrError) => {
      if (warningOrError.category !== 'caseLogic') {
        return warningOrError;
      }
      if (parentNodeId) {
        // Effect chain is used from within an EC node, just change the node id reported to be
        // the EC instead of the child node
        return merge({}, warningOrError, {
          id: parentNodeId,
          metadata: { nodeId: parentNodeId },
        });
      }
      if (medication) {
        // Effect chain is used from within a medication
        // If it's a case logic error, report it on the
        // medication instead
        return merge({}, warningOrError, {
          category: 'medications',
          field: 'medication',
          subField: 'effectChain',
          id: medication.id,
        });
      }
      return warningOrError;
    };

    const ecWarningsScopedToEcNodeOrMedication = ecWarnings.map(
      scopeErrorToEcNodeOrMedication
    );
    const ecErrorsScopedToEcNodeOrMedication = ecErrors.map(
      scopeErrorToEcNodeOrMedication
    );

    warnings.push(...ecWarningsScopedToEcNodeOrMedication);
    errors.push(...ecErrorsScopedToEcNodeOrMedication);
  });

  return {
    errors,
    warnings,
  };
}

export default validateEffectChains;
